var text_field_default = {
  "root": "X7963",
  "text": "FWdXd",
  "input": "-I02v",
  "small": "x2wdG",
  "medium": "IBvC4",
  "large": "Bg3Uu",
  "webview": "FI8F-",
  "endAdornment": "ojLvX",
  "shown": "jqzx-",
  "value": "bcv0i",
  "spinner": "eQqdk",
  "spin": "Y8c7r"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
